import React from "react";

import { Card, Divider, Stack, styled } from '@material-ui/core';
import { User } from "../../types";
import timeAgo from "../../utils/timeAgo";
import ValueWithLabel from "../../components/ValueWithLabel";





const Root = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});


interface Props {
  user: User;
}
const BasicInfo: React.FC<Props> = ({ user }) => {
  let locationLabel = '';
  if (user.location?.cityLocales) {
    locationLabel = user.location.cityLocales?.en;
  }
  if (user.location?.districtLocales) {
    locationLabel = `${locationLabel}, ${user.location.districtLocales.en}`
  }
  if (user.location?.stateLocales) {
    locationLabel = `${locationLabel}, ${user.location.stateLocales.en}`
  }
  if (user.location?.countryLocales) {
    locationLabel = `${locationLabel}, ${user.location.countryLocales.en}`
  }

  return (
    <Root>

      <Card sx={{p: 2}} variant="outlined">
        <Stack divider={<Divider />} spacing={1}>
          <Stack direction="row" spacing={5}>
            <ValueWithLabel label="Status" value={user.status} />
            <ValueWithLabel label="First name" value={user.firstName} />
            <ValueWithLabel label="Last name" value={user.lastName} />
          </Stack>
          <Stack direction="row" spacing={5}>
            <ValueWithLabel label="Wallet Coins" value={user.wallet.coins} />
            <ValueWithLabel label="In App Products" value={user.appFeatures ? Object.keys(user.appFeatures).length : 0} />
            <ValueWithLabel label="Ad Rewards" value={user.rewardStats?.total ?? 0} />
          </Stack>
          <Stack direction="row" spacing={5}>
            <ValueWithLabel label="Registered" value={timeAgo(user.createTime.toDate())} />
            <ValueWithLabel label="Last active" value={timeAgo(user.lastActiveTimeInternal?.toDate())} />
          </Stack>
          <Stack direction="row" spacing={5}>
            <ValueWithLabel label="Chats" value={user.chatStats?.total ?? 0} />
            <ValueWithLabel label="Swipes" value={user.swipeStats?.total ?? 0} />
            <ValueWithLabel label="Matches" value={user.matchedUsers ? Object.keys(user.matchedUsers).length : 0} />
          </Stack>
          <Stack direction="row" spacing={5}>
            <ValueWithLabel label="Gender" value={user.gender} />
            <ValueWithLabel label="Age" value={user.age} />
            <ValueWithLabel label="Date of birth" value={new Date(user.dob.year, user.dob.month - 1, user.dob.day).toDateString()} />
          </Stack>
          <ValueWithLabel label="Location" value={locationLabel} />
          <ValueWithLabel label="Profile hidden" value={user.profileHidden ? 'YES' : 'NO'} />
          <ValueWithLabel label="About" value={user.about} />
        </Stack>
      </Card>

    </Root>
  );
};

export default BasicInfo;